import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzLayoutModule } from 'ng-zorro-antd/layout';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RequestResetPasswordComponent } from './request-reset-password/request-reset-password.component';
import { LoginComponent } from './login/login.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { SaleEventService } from '../sale-event-service.service';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { VerifyUserEmailComponent } from './verify-user-email/verify-user-email.component';
import { RegisterComponent } from './register/register.component';
import { PrivateRegisterComponent } from './private-register/private-register.component';
import { PurplePipeModule, PurpleSelectModule, Guid, PurpleGeneralDirectiveModule, PurpleEditImageModule, PurpleEditTextModule, PurpleFormModule } from 'purple-lib';
import { PurpleSalesComponentsModule } from '../components/purple-sales-components.module';

@NgModule({
  declarations: [
    RequestResetPasswordComponent,
    LoginComponent,
    ResetPasswordComponent,
    VerifyUserEmailComponent,
    RegisterComponent,
    PrivateRegisterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzCheckboxModule,
    NzFormModule,
    NzInputModule,
    NzSelectModule,
    ReactiveFormsModule,
    NzLayoutModule,
    PurplePipeModule,
    NzDropDownModule,
    PurpleGeneralDirectiveModule,
    RouterModule,
    PurpleSelectModule,
    NzIconModule,
    NzNotificationModule,
    PurpleEditImageModule,
    PurpleEditTextModule,
    PurpleSalesComponentsModule,
    PurpleFormModule
  ],
  providers:[
    SaleEventService,
    Guid
  ]
})
export class AuthenticationModule { }
